import React, { useContext, useEffect, useState } from "react";
import AdminContext from "../../StateContext/Application";
import { apiurl } from "../../../../path";
import { useLanguage } from "../../../../lang/langcontext/LanguageContext";
import * as XLSX from "xlsx";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import GooglePagination from "../../styles/GooglePagination";
import CommonFilters from "../../../../utils/CommonFilters";
import {
  formatDateTime,
  formatDate,
  formatFileName,
  getBillDeadlineForProposalYear,
} from "../../../../utils/DateFormat";
import { districtTalukaMap, getColumnName, setupDistrictTalukaData, applyDistrictTalukaDropdowns } from "../../../../utils/districtTalukaDropdown";

const WorkOrderOutwards = () => {
  const { language, toggleLanguage, t } = useLanguage();
  const context = useContext(AdminContext);
  const { WorkOutwards, GetBudgetHeadInfo, Usermenu, UploadExtensionOrder } =
    context;
  const [proposallist, setProposalList] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const budgetEstimation = proposallist;
  const [filteredBills, setFilteredBills] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const billsPerPage = 10;
  const [selectedProposal, setSelectedProposal] = useState(null);
  const [statusofData, setstatusofData] = useState("");
  const [UserRole, setUserRole] = useState("");
  const [loginDistrict, setLoginDistrict] = useState("");
  const [selectedHeadCode, setSelectedHeadCode] = useState("");
  const [selectedDepartment, setSelectedDepartment] = useState("");
  const [userDepartmentIds, setUserDepartmentIds] = useState([]);

  const [totalEntryCount, setTotalEntryCount] = useState(0);
  const [AllDistrict, setAllDistrict] = useState([]);
  const [TalukasofDistrict, setTalukasofDistrict] = useState([]);
  const [SelectedDistrict, setSelectedDistrict] = useState([]);
  // const [SelectedTalukasofDistrict, setSelectedTalukasofDistrict] = useState("");
  const [openDistrict, setOpenDistrict] = useState(false);
  const [openTaluka, setOpenTaluka] = useState(false);
  const [loading, setloading] = useState(false);
  const [RoleID, setroleID] = useState(null);
  const [typeofData, settypeofData] = useState("District");
  const [showExtensionModal, setShowExtensionModal] = useState(false);
  const [extensionTargetWO, setExtensionTargetWO] = useState(null); // full proposal row
  const [extensionFile, setExtensionFile] = useState(null);
  const [uploadingExtension, setUploadingExtension] = useState(false);
  const totalPages = Math.ceil(filteredBills?.length / billsPerPage);
  const indexOfLastBill = currentPage * billsPerPage;
  const indexOfFirstBill = indexOfLastBill - billsPerPage;
  const [SelectedTaluka, setSelectedTaluka] = useState([]);
  const sortedBills = Array.isArray(filteredBills)
    ? filteredBills
      .slice() // ✅ prevent state mutation
      .sort((a, b) => new Date(b.Date) - new Date(a.Date))
    : [];
  const currentBills = sortedBills?.slice(indexOfFirstBill, indexOfLastBill);
  // const currentBills = filteredBills?.slice(indexOfFirstBill, indexOfLastBill);
  const [exportingPDF, setExportingPDF] = useState(false);
  //  work type filter
  const [selectedWorkType, setSelectedWorkType] = useState("");
  const [mhuidSearch, setMhuidSearch] = useState("");

  const displayedGRS = exportingPDF ? filteredBills : currentBills;
  const headerStyle = {
    padding: "12px 16px",
    whiteSpace: "nowrap",
    borderRight: "1px solid #e0e0e0",
    textTransform: "capitalize",
  };
  const proposalEstimate = async () => {
    let data = await WorkOutwards();
    const { status, message, Tabletype } = data;
    if (status) {
      setProposalList(message);
      console.log("this is for work order outward", message);
      setUserRole(Tabletype);
    } else {
      alert(message);
    }
  };
  const getmenu = async () => {
    try {
      const data = await Usermenu();
      if (!data || typeof data !== "object") {
        console.error("Invalid data:", data);
        return;
      }
      const roleID = data?.Data?.RoleID;
      setroleID(roleID);
      console.log("sffdsf", data?.Data);
      const district = data?.Data?.District;
      setLoginDistrict(district);
       // "[1,2]", [1,2], "1,2" -> ["1", "2"]
      const ids = String(data?.Data?.DepartmentAccessID ?? "").match(/\d+/g) || [];
      setUserDepartmentIds(ids);
    } catch (error) {
      console.error("Error in AdminNavbar getmenu:", error);
    }
  };

  const showDepartmentFilter =
    userDepartmentIds.includes("1") && userDepartmentIds.includes("2");

  const getDepartmentKey = (item) => {
    const ids = String(item?.DepartmentAccessID ?? "").match(/\d+/g) || [];
    return ids.includes("1") ? "1" : ids[0] || "";
  };

  useEffect(() => {
    proposalEstimate();
    getmenu();
  }, []);

  const allDistricts = [
    ...new Set(
      AllDistrict?.map((d) =>
        d?.District_Marathi?.split("-")[0]?.trim()
      ).filter(Boolean)
    ),
  ];

  const isAllSelected =
    allDistricts.length > 0 &&
    SelectedDistrict.length === allDistricts.length;

  const toggleAllDistricts = () => {
    setSelectedDistrict(isAllSelected ? [] : allDistricts);
  };
  const handleDistrictToggle = (district) => {
    setSelectedDistrict((prev) =>
      prev.includes(district)
        ? prev.filter((d) => d !== district)
        : [...prev, district],
    );
  };

  useEffect(() => {
    if (UserRole === "State") {
      setSelectedTaluka("");
    }
  }, [SelectedDistrict, UserRole]);
  useEffect(() => {
    let filtered = [...budgetEstimation];
    if (typeofData === "District" && RoleID === 29) {
      filtered = filtered.filter(
        (item) =>
          item.HeadCode ===
          "3054-2419(Roads and bridge repair maintenance program)",
      );
      console.log("filtered Date 3054", filtered);
    } else if (typeofData === "State" && RoleID === 29) {
      filtered = filtered.filter(
        (item) => item.HeadCode === "2515-1238(MLA Representative)",
      );
    }
    // 🔹 Filter by District
    if (SelectedDistrict?.length > 0) {
      filtered = filtered.filter((item) => {
        const itemDistrict = item.talulka || "";

        return SelectedDistrict.some(
          (district) =>
            itemDistrict === district ||
            itemDistrict.startsWith(`${district}-`)
        );
      });
    }

    // 🔹 Filter by Taluka
    // if (SelectedTaluka) {
    //   filtered = filtered.filter((item) => item.ulb === SelectedTaluka);
    // }
    if (SelectedTaluka.length > 0) {
      filtered = filtered.filter((item) => SelectedTaluka.includes(item.ulb));
    }

    // 🔹 Filter by Status
    if (statusofData) {
      if (statusofData === "Pending") {
        filtered = filtered.filter(
          (item) =>
            item.Status == "Pending" &&
            (item.Approvance1 === "false" ||
              item.Approvance2 === "false" ||
              item.Approvance3 === "false"),
        );
      } else if (statusofData === "Approved") {
        // ✅ Added block
        filtered = filtered.filter(
          (item) =>
            item.Approvance1 === "true" &&
            item.Approvance2 === "true" &&
            item.Approvance3 === "true",
        );
      } else if (statusofData === "Rejected") {
        filtered = filtered.filter(
          (item) =>
            item.Status !== "Pending" &&
            (item.Status === "Rejected")
        );
      } else {
        filtered = filtered.filter((item) => item.Status === statusofData);
      }
    }

    // 🔹 Search Filter
    if (searchTerm.trim()) {
      const lower = searchTerm.toLowerCase();
      filtered = filtered.filter((item) =>
        Object.values(item).some((val) =>
          String(val ?? "")
            .toLowerCase()
            .includes(lower),
        ),
      );
    }
    // 🔹 Filter by Work Order Type
    if (selectedWorkType && selectedWorkType !== "Expired") {
      filtered = filtered.filter(
        (item) => item.WorkOrderType === selectedWorkType,
      );
    }
    // 🔹 Filter by Department
    if (selectedDepartment) {
      filtered = filtered.filter(
        (item) => getDepartmentKey(item) === selectedDepartment
      );
    }

    // 🔹 Filter by MHUID search
    if (mhuidSearch.trim()) {
      filtered = filtered.filter((item) =>
        String(item.TechnicalUID ?? "")
          .toLowerCase()
          .includes(mhuidSearch.toLowerCase()),
      );
    }

    // 🔹 Filter by Expired status
    if (selectedWorkType === "Expired") {
      filtered = filtered.filter((item) => isWorkOrderExpired(item));
    }

    // Keep total count including Jalna
    setTotalEntryCount(filtered.length); ///Always keep this before setFilteredBills(filtered);

    // 🔹 Filter by selected Head Code
    if (selectedHeadCode) {
      filtered = filtered.filter((item) => item.HeadCode === selectedHeadCode);
    }

    // RoleID 80/81 → always restrict to 2515 records only
    if (RoleID === 80 || RoleID === 81) {
      filtered = filtered.filter((item) => item.HeadCode?.startsWith("2515"));
    }

    // Keep total count including Jalna
    setTotalEntryCount(filtered.length); ///Always keep this before setFilteredBills(filtered);

    // Hide 2515 Jalna/Nanded records by default for District login
    // (skipped once the user explicitly filters by a head code, e.g. picks 2515)
    if (
      (loginDistrict === "जालना" || loginDistrict === "नांदेड") &&
      RoleID !== 40 &&
      RoleID !== 41 &&
      RoleID !== 80 &&
      RoleID !== 81 &&
      SelectedDistrict.length === 0 &&
      !selectedHeadCode
    ) {
      filtered = filtered.filter((item) => {
        const is2515 = item.HeadCode?.startsWith("2515");
        const itemDistrict = item.talulka || "";

        const isJalnaNanded =
          itemDistrict === "जालना" ||
          itemDistrict.startsWith("जालना-") ||
          itemDistrict === "नांदेड" ||
          itemDistrict.startsWith("नांदेड-");

        return !(is2515 && isJalnaNanded);
      });
    }

    // Hide 2515 Jalna/Nanded records by default for State 40/41 login
    if ((RoleID === 40 || RoleID === 41) && SelectedDistrict.length === 0) {
      filtered = filtered.filter((item) => {
        const itemDistrict = item.talulka || "";

        return !(
          itemDistrict === "जालना" ||
          itemDistrict.startsWith("जालना-") ||
          itemDistrict === "नांदेड" ||
          itemDistrict.startsWith("नांदेड-")
        );
      });
    }

    // Addeddddd New Set count AFTER every filter (including Jalna/Nanded exclusion) has run
    setTotalEntryCount(filtered.length);
    setFilteredBills(filtered);
    setCurrentPage(1);
  }, [
    budgetEstimation,
    SelectedDistrict,
    statusofData,
    searchTerm,
    typeofData,
    selectedWorkType,
    mhuidSearch,
    SelectedTaluka,
    UserRole,
    RoleID,
    loginDistrict,
    selectedHeadCode,
    selectedDepartment,
  ]);

  // /////ADDED NEW CODE FOR TALUKA DROPDOWN BASED ON SELECTED DISTRICT
  const availableTalukas = [
    ...new Set(
      SelectedDistrict.flatMap(
        (district) => districtTalukaMap[district] || []
      )
    )
  ];
  useEffect(() => {
    setSelectedTaluka([]);
    setOpenTaluka(false);
  }, [SelectedDistrict]);



  const selectedBillDetails = (BillID) => {
    const result = budgetEstimation
      .filter((item) => item.WorkOrderID == BillID)
      .map((item) => ({
        "Work Order UID": item.WorkOrderID,
        "Work Order Number": item.WorkOrderNo,
        "Work Name": item.WorkName,
        "Head Code": item.HeadCode,
        "Proposal UID": item.ProposalID,
        "Proposal Year": item.ProposalYear,
        District: item.talulka,
        "Approved Work Amount": item.ApprovedWorkAmount,
        // "Remaining Amount": item.BillPaidAmount,
        "Remaining Amount": item.RemainingAmount,
        // "Paid Amount": item.PaidAmount,
        "Work Order Date": new Date(item.WorkOrderDate).toLocaleString(),
        "Work Order End Date": new Date(item.WorkEndDate).toLocaleString(),
        "Work Order Copy": item.CopyofWorkOrder,
        "Creation Date": formatDateTime(item.Date),
      }));

    console.log("------------------", result);
    setSelectedProposal(result[0]);
  };

  // ── Old: checked WorkEndDate — replaced with Administrative Approved Year deadline rule ──
  const isWorkOrderExpired = (proposal) => {
    const deadlineStr = getBillDeadlineForProposalYear(
      proposal?.HeadCode,
      proposal?.ProposalYear,
    );
    if (!deadlineStr) return false;

    const deadline = new Date(deadlineStr);
    deadline.setHours(23, 59, 59, 999);
    const today = new Date();

    return today > deadline;
  };

  const FetchGramPanachayatInfo = async () => {
    try {
      let res = await GetBudgetHeadInfo("null", "AllDistrict");
      // console.log("Data i get:: ", res);
      setAllDistrict(res);
    } catch (err) {
      console.log(err);
    }
  };

  useEffect(() => {
    FetchGramPanachayatInfo();
  }, []);

  const totalworkordercost = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.ProjectCost);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totalApproveamt1 = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.ApprovedWorkAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const totalremaningamt = filteredBills?.reduce((sum, item) => {
    const amount = Number(item?.BillRemainingAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const pagetotalworkcostamt = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.ProjectCost);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const pagetotalapprovedamt = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.ApprovedWorkAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const pagetotalremaingamt = currentBills?.reduce((sum, item) => {
    const amount = Number(item?.BillRemainingAmount);
    return sum + (isNaN(amount) ? 0 : amount);
  }, 0);
  const exportTableByClassToExcel = async (
    currentBills,
    filename = "Work_Details_Outward.xlsx"
  ) => {
    if (!Array.isArray(currentBills) || currentBills.length === 0) {
      alert("No data available");
      return;
    }

    setloading(true);

    await new Promise((resolve) => setTimeout(resolve, 1000));

    try {
      let totalworkordercost = 0;
      let totalApproveAmt = 0;
      let totalRemainingAmt = 0;
      let totalPaidAmt = 0;

      const excelData = currentBills.map((proposal, index) => {

        const workordercost = Number(proposal.ProjectCost || 0);
        const approved = Number(proposal.ApprovedWorkAmount || 0);
        const remaining = Number(proposal.RemainingAmount || 0);
        const paid = Number(proposal.PaidAmount || 0);

        totalworkordercost += Number.isNaN(workordercost)
          ? 0
          : workordercost;

        totalApproveAmt += Number.isNaN(approved)
          ? 0
          : approved;

        totalRemainingAmt += Number.isNaN(remaining)
          ? 0
          : remaining;

        totalPaidAmt += Number.isNaN(paid)
          ? 0
          : paid;

        return {
          "Sr.No": index + 1,

          "Administrative Year":
            proposal.ProposalYear || "",

          Taluka:
            proposal.ulb || "",

          "Work Order UID":
            proposal.WorkOrderID || "",

          "Work Order Number":
            proposal.WorkOrderNo || "",

          "Work Name":
            proposal.WorkName || "",

          "Work Order Type":
            proposal.WorkOrderType || "",

          "Job ID":
            proposal.JOB_ID || "",

          "Contractor Name":
            proposal.ContractorName || "",

          // "MHUID Number":
          //   proposal.TechnicalUID || "",

          "MHUID Number":
            !proposal.TechnicalUID ||
            String(proposal.TechnicalUID).trim().toUpperCase() === "NULL" ||
            String(proposal.TechnicalUID).trim().toLowerCase() === "undefined" ||
            String(proposal.TechnicalUID).trim() === ""
              ? "-"
              : proposal.TechnicalUID,

          District:
            proposal.talulka || "",

          // ✅ Work Cost
          "Work Cost":
            workordercost,

          "Approved Work Amount":
            approved,

          "Remaining Amount":
            remaining,

          "Creation Date":
            proposal.WorkOrderDate
              ? new Date(
                proposal.WorkOrderDate
              ).toLocaleDateString()
              : "",

          "Work Order End Date":
            proposal.WorkEndDate
              ? new Date(
                proposal.WorkEndDate
              ).toLocaleDateString()
              : "",

          "Administrative Approved GR Date":
            proposal.workApprovedGRDate
              ? new Date(
                proposal.workApprovedGRDate
              ).toLocaleDateString()
              : "-",

          Date:
            proposal.Date
              ? new Date(
                proposal.Date
              ).toLocaleDateString()
              : "",

          "Rejected?":
            proposal.Status === "Pending"
              ? "No"
              : "Yes",

          Remark:
            proposal.Remark || "--",

          "Department HOD(EE)":
            proposal.Approvance3 === "true"
              ? "Approved"
              : proposal.Approvance3 === "false"
                ? "Rejected"
                : "-",
        };
      });

      excelData.push({
        "Sr.No": "",

        "Administrative Year": "",

        Taluka: "",

        "Work Order UID": "",

        "Work Order Number": "",

        "Work Name": "",

        "Work Order Type": "",

        "Job ID": "",

        "Contractor Name": "",

        "MHUID Number": "",

        // TOTAL label
        District: "TOTAL",

        // ✅ Correct numeric Work Cost total
        "Work Cost": totalworkordercost,

        // ✅ Approved total
        "Approved Work Amount":
          totalApproveAmt,

        // ✅ Remaining total
        "Remaining Amount":
          totalRemainingAmt,

        "Creation Date": "",

        "Work Order End Date": "",

        "Administrative Approved GR Date":
          "",

        Date: "",

        "Rejected?": "",

        Remark: "",

        "Department HOD(EE)": "",
      });

      const worksheet =
        XLSX.utils.json_to_sheet(excelData);


      worksheet["!cols"] = [
        { wch: 8 },  // Sr.No
        { wch: 22 }, // Administrative Year
        { wch: 18 }, // Taluka
        { wch: 20 }, // Work Order UID
        { wch: 22 }, // Work Order Number
        { wch: 35 }, // Work Name
        { wch: 20 }, // Work Order Type
        { wch: 18 }, // Job ID
        { wch: 25 }, // Contractor Name
        { wch: 20 }, // MHUID
        { wch: 20 }, // District
        { wch: 18 }, // Work Cost
        { wch: 22 }, // Approved
        { wch: 22 }, // Remaining
        { wch: 18 }, // Creation Date
        { wch: 22 }, // End Date
        { wch: 30 }, // GR Date
        { wch: 18 }, // Date
        { wch: 15 }, // Rejected
        { wch: 30 }, // Remark
        { wch: 22 }, // HOD
      ];

      worksheet["!freeze"] = {
        xSplit: 0,
        ySplit: 1,
      };

      worksheet["!autofilter"] = {
        ref: XLSX.utils.encode_range({
          s: {
            r: 0,
            c: 0,
          },

          e: {
            r: excelData.length - 2,
            c:
              Object.keys(excelData[0]).length - 1,
          },
        }),
      };

      const workbook =
        XLSX.utils.book_new();

      XLSX.utils.book_append_sheet(
        workbook,
        worksheet,
        "Work Details"
      );

      XLSX.writeFile(
        workbook,
        filename
      );
    } catch (error) {
      console.error(
        "Excel Export Error:",
        error
      );

      alert(
        "Error while generating Excel file."
      );
    } finally {
      setloading(false);
    }
  };

  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   setExportingPDF(true);
  //   await new Promise(res => setTimeout(res, 300));

  //   const table = document.querySelector(`.${tableClass}`);
  //   if (!table) {
  //     setExportingPDF(false);
  //     return;
  //   }

  //   const pdf = new jsPDF("p", "mm", "a4");
  //   const pageWidth = pdf.internal.pageSize.getWidth();
  //   const pageHeight = pdf.internal.pageSize.getHeight();

  //   const topMargin = 25;
  //   const sideMargin = 10;
  //   const bottomMargin = 15;

  //   pdf.setFontSize(16);
  //   pdf.setFont("helvetica", "bold");
  //   pdf.text(title, pageWidth / 2, 15, { align: "center" });

  //   const canvas = await html2canvas(table, {
  //     scale: 1,
  //     useCORS: true,
  //     backgroundColor: "#2C78DB",
  //   });

  //   const imgWidth = pageWidth - sideMargin * 2;

  //   // 🔥 Correct pixel-to-mm ratio
  //   const pxToMm = imgWidth / canvas.width;

  //   const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //   const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //   let renderedHeight = 0;
  //   let pageNumber = 0;

  //   while (renderedHeight < canvas.height) {
  //     const sliceHeight = Math.min(
  //       usablePageHeightPx,
  //       canvas.height - renderedHeight
  //     );

  //     const pageCanvas = document.createElement("canvas");
  //     const context = pageCanvas.getContext("2d");

  //     pageCanvas.width = canvas.width;
  //     pageCanvas.height = sliceHeight;

  //     context.drawImage(
  //       canvas,
  //       0,
  //       renderedHeight,
  //       canvas.width,
  //       sliceHeight,
  //       0,
  //       0,
  //       canvas.width,
  //       sliceHeight
  //     );

  //     const imgData = pageCanvas.toDataURL("image/jpeg", 0.9);

  //     if (pageNumber > 0) pdf.addPage();

  //     pdf.addImage(
  //       imgData,
  //       "JPEG",
  //       sideMargin,
  //       topMargin,
  //       imgWidth,
  //       sliceHeight * pxToMm
  //     );

  //     renderedHeight += sliceHeight;
  //     pageNumber++;
  //   }

  //   pdf.save(filename);
  //   setExportingPDF(false);
  // };
  // const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
  //   const CHUNK_SIZE = 500; // 🔥 Adjust if needed (300–500 recommended)

  //   const originalTable = document.querySelector(`.${tableClass}`);
  //   if (!originalTable) {
  //     setExportingPDF(false);
  //     alert("Table not found");
  //     return;
  //   }

  //   setloading(true);
  //   setExportingPDF(true);

  //   await new Promise((res) => setTimeout(res, 400));

  //   try {
  //     const originalRows = originalTable.querySelectorAll("tbody tr");
  //     const totalRows = originalRows.length;

  //     for (let start = 0; start < totalRows; start += CHUNK_SIZE) {
  //       const end = Math.min(start + CHUNK_SIZE, totalRows);

  //       // 🔥 Clone only required chunk
  //       const table = originalTable.cloneNode(true);
  //       const rows = table.querySelectorAll("tbody tr");

  //       rows.forEach((row, index) => {
  //         if (index < start || index >= end) {
  //           row.remove();
  //         }
  //       });

  //       document.body.appendChild(table);

  //       const pdf = new jsPDF("p", "mm", "a4");
  //       const pageWidth = pdf.internal.pageSize.getWidth();
  //       const pageHeight = pdf.internal.pageSize.getHeight();

  //       const topMargin = 25;
  //       const sideMargin = 10;
  //       const bottomMargin = 15;

  //       pdf.setFontSize(16);
  //       pdf.setFont("helvetica", "bold");
  //       pdf.text(`${title} (${start + 1} - ${end})`, pageWidth / 2, 15, {
  //         align: "center",
  //       });

  //       const canvas = await html2canvas(table, {
  //         scale: 1,
  //         useCORS: true,
  //         backgroundColor: "#2C78DB",
  //       });

  //       const imgWidth = pageWidth - sideMargin * 2;
  //       const pxToMm = imgWidth / canvas.width;

  //       const usablePageHeightMm = pageHeight - topMargin - bottomMargin;
  //       const usablePageHeightPx = usablePageHeightMm / pxToMm;

  //       let renderedHeight = 0;
  //       let pageNumber = 0;

  //       while (renderedHeight < canvas.height) {
  //         const sliceHeight = Math.min(
  //           usablePageHeightPx,
  //           canvas.height - renderedHeight,
  //         );

  //         const pageCanvas = document.createElement("canvas");
  //         const context = pageCanvas.getContext("2d");

  //         pageCanvas.width = canvas.width;
  //         pageCanvas.height = sliceHeight;

  //         context.drawImage(
  //           canvas,
  //           0,
  //           renderedHeight,
  //           canvas.width,
  //           sliceHeight,
  //           0,
  //           0,
  //           canvas.width,
  //           sliceHeight,
  //         );

  //         const imgData = pageCanvas.toDataURL("image/jpeg", 0.85);

  //         if (pageNumber > 0) pdf.addPage();

  //         pdf.addImage(
  //           imgData,
  //           "JPEG",
  //           sideMargin,
  //           topMargin,
  //           imgWidth,
  //           sliceHeight * pxToMm,
  //         );

  //         renderedHeight += sliceHeight;
  //         pageNumber++;
  //       }

  //       pdf.save(`${filename}_${start + 1}_to_${end}.pdf`);

  //       document.body.removeChild(table);

  //       // 🔥 Small delay to prevent freezing
  //       await new Promise((res) => setTimeout(res, 300));
  //     }
  //   } catch (error) {
  //     console.error("PDF Export Error:", error);
  //   } finally {
  //     setExportingPDF(false);
  //     setloading(false);
  //   }
  // };

  // Added New for start with index 1
  const downloadTableOnlyAsPDF = async (tableClass, filename, title) => {
    const CHUNK_SIZE = 500;
    const TOTAL_SUMMARY_ROWS = 2; // Existing Page Total + Gross Total

    const originalTable = document.querySelector(`.${tableClass}`);

    if (!originalTable) {
      setExportingPDF(false);
      alert("Table not found");
      return;
    }

    setloading(true);
    setExportingPDF(true);

    await new Promise((res) => setTimeout(res, 400));

    if (document.fonts && document.fonts.ready) {
      await document.fonts.ready;
    }

    try {
      const originalAllRows = Array.from(
        originalTable.querySelectorAll("tbody tr")
      );

      // Remove existing Page Total + Gross Total rows
      const summaryRows = originalAllRows.slice(-TOTAL_SUMMARY_ROWS);

      const dataRows = originalAllRows.slice(
        0,
        originalAllRows.length - TOTAL_SUMMARY_ROWS
      );

      const totalDataRows = dataRows.length;

      if (totalDataRows === 0) {
        alert("No records found to download.");
        setExportingPDF(false);
        setloading(false);
        return;
      }

      const grossTotalRow = summaryRows[1];

      let totalRow = null;

      if (grossTotalRow) {
        totalRow = grossTotalRow.cloneNode(true);

        // Change first cell text to "Total"
        const totalCells = totalRow.querySelectorAll("td");

        if (totalCells.length > 0) {
          totalCells[0].textContent = "Total";
        }

        // Optional: remove any Page Total text that may exist
        totalRow.querySelectorAll("td").forEach((cell) => {
          cell.style.fontWeight = "bold";
        });
      }

      const headerRow =
        originalTable.querySelector("thead tr") || originalAllRows[0];

      const referenceCells = Array.from(headerRow.children);

      const columnWidths = referenceCells.map(
        (cell) => cell.getBoundingClientRect().width
      );

      const totalTableWidth = columnWidths.reduce((a, b) => a + b, 0);

      const reversedDataRows = [...dataRows].reverse();

      for (
        let start = 0;
        start < totalDataRows;
        start += CHUNK_SIZE
      ) {
        const end = Math.min(start + CHUNK_SIZE, totalDataRows);

        const isLastChunk = end >= totalDataRows;

        const chunkRows = reversedDataRows.slice(start, end);

        // Clone table
        const table = originalTable.cloneNode(true);

        const tbody = table.querySelector("tbody");

        // Remove all existing tbody rows
        const clonedRows = Array.from(tbody.querySelectorAll("tr"));

        clonedRows.forEach((row) => row.remove());

        // Add data rows
        chunkRows.forEach((originalRow, index) => {
          const row = originalRow.cloneNode(true);

          const firstCell = row.querySelector("td");

          if (firstCell) {
            firstCell.textContent = start + index + 1;
          }

          tbody.appendChild(row);
        });
        if (isLastChunk && totalRow) {
          tbody.appendChild(totalRow.cloneNode(true));
        }

        table.style.tableLayout = "fixed";
        table.style.width = `${totalTableWidth}px`;

        // Remove existing colgroup
        const existingColgroup = table.querySelector("colgroup");

        if (existingColgroup) {
          existingColgroup.remove();
        }

        // Create column widths
        const colgroup = document.createElement("colgroup");

        columnWidths.forEach((w) => {
          const col = document.createElement("col");

          col.style.width = `${w}px`;

          colgroup.appendChild(col);
        });

        table.insertBefore(colgroup, table.firstChild);

        table.style.position = "absolute";
        table.style.left = "-99999px";
        table.style.top = "0";

        document.body.appendChild(table);


        const tableRect = table.getBoundingClientRect();

        const allDomRows = Array.from(table.querySelectorAll("tr"));

        const rowBoundaries = allDomRows.map(
          (r) =>
            r.getBoundingClientRect().bottom -
            tableRect.top
        );

        const pdf = new jsPDF("p", "mm", "a4");

        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        const topMargin = 25;
        const sideMargin = 10;
        const bottomMargin = 15;

        pdf.setFontSize(16);
        pdf.setFont("helvetica", "bold");

        pdf.text(
          `${title} (${start + 1} - ${end})`,
          pageWidth / 2,
          15,
          {
            align: "center",
          }
        );

        const canvas = await html2canvas(table, {
          scale: 2,
          useCORS: true,
          backgroundColor: "#2C78DB",
          windowWidth: table.scrollWidth,
        });

        const imgWidth = pageWidth - sideMargin * 2;

        const pxToMm = imgWidth / canvas.width;

        const usablePageHeightMm =
          pageHeight - topMargin - bottomMargin;

        const usablePageHeightPx =
          usablePageHeightMm / pxToMm;

        let renderedHeight = 0;
        let pageNumber = 0;

        while (renderedHeight < canvas.height) {
          let sliceEnd =
            renderedHeight + usablePageHeightPx;

          if (sliceEnd >= canvas.height) {
            sliceEnd = canvas.height;
          } else {
            let bestBoundary = null;

            for (const b of rowBoundaries) {
              if (
                b > renderedHeight &&
                b <= sliceEnd
              ) {
                bestBoundary = b;
              }
            }

            if (bestBoundary) {
              sliceEnd = bestBoundary;
            }
          }

          const sliceHeight =
            sliceEnd - renderedHeight;

          const pageCanvas =
            document.createElement("canvas");

          const context =
            pageCanvas.getContext("2d");

          pageCanvas.width = canvas.width;

          pageCanvas.height =
            Math.ceil(sliceHeight);

          context.drawImage(
            canvas,
            0,
            renderedHeight,
            canvas.width,
            sliceHeight,
            0,
            0,
            canvas.width,
            sliceHeight
          );

          const imgData =
            pageCanvas.toDataURL(
              "image/jpeg",
              0.85
            );

          if (pageNumber > 0) {
            pdf.addPage();
          }

          pdf.addImage(
            imgData,
            "JPEG",
            sideMargin,
            topMargin,
            imgWidth,
            sliceHeight * pxToMm
          );

          renderedHeight = sliceEnd;

          pageNumber++;
        }

        pdf.save(
          `${filename}_${start + 1}_to_${end}.pdf`
        );

        document.body.removeChild(table);

        await new Promise((res) =>
          setTimeout(res, 300)
        );
      }
    } catch (error) {
      console.error(
        "PDF Export Error:",
        error
      );

      alert("Error while generating PDF.");
    } finally {
      setExportingPDF(false);
      setloading(false);
    }
  };

  useEffect(() => {
    if (UserRole === "State") {
      setSelectedTaluka("");
    }
  }, [SelectedDistrict, UserRole]);

  const handleUploadExtensionOrder = async () => {
    if (!extensionFile) {
      alert(t("Please choose a file to upload"));
      return;
    }
    if (!extensionTargetWO?.WorkOrderID) {
      alert(t("Work Order not found"));
      return;
    }

    setUploadingExtension(true);
    try {
      const formData = new FormData();
      formData.append("WorkOrderID", extensionTargetWO.WorkOrderID);
      formData.append("ExtensionOrder", extensionFile);

      const result = await UploadExtensionOrder(formData);

      if (result?.message) {
        alert(result.message);
        setShowExtensionModal(false);
        setExtensionFile(null);
        setExtensionTargetWO(null);
        await proposalEstimate(); // refresh list so badge updates
      } else {
        alert(result?.error || t("Failed to upload Extension Order"));
      }
    } catch (err) {
      console.error("handleUploadExtensionOrder error:", err);
      alert(t("Something went wrong while uploading"));
    } finally {
      setUploadingExtension(false);
    }
  };

  const isChecker =
    RoleID === 80 ||
    RoleID === 81 ||
    ((RoleID === 40 || RoleID === 41) &&
      (SelectedDistrict.includes("जालना") ||
        SelectedDistrict.includes("नांदेड"))) ||
    ((loginDistrict === "जालना" || loginDistrict === "नांदेड") &&
      selectedHeadCode?.startsWith("2515"));

  const headCodeOptions = [
    ...new Set(
      budgetEstimation
        ?.map((item) => item.HeadCode)
        .filter(Boolean)
    ),
  ].sort();

  const talukaOptions = [
    ...new Set(
      budgetEstimation
        ?.filter((item) => {
          if (UserRole === "State") {
            // No district selected yet -> don't show any taluka
            if (!(SelectedDistrict?.length > 0)) {
              return false;
            }
            return SelectedDistrict.some(
              (district) =>
                item.talulka === district ||
                item.talulka?.startsWith(`${district}-`)
            );
          }

          return true;
        })
        .map((item) => item.ulb)
        .filter(Boolean)
    ),
  ].sort();

  return (
    <>
      <div
        className="col-12 pb-5"
        style={{
          backgroundColor: "#EFF3F8",
          height: "90vh",
          overflowX: "hidden",
          overflowY: "scroll",
          position: "relative",
        }}
      >
        {/* 🔥 Blur Wrapper */}
        <div
          style={{
            filter: loading ? "blur(4px)" : "none",
            pointerEvents: loading ? "none" : "auto",
            transition: "0.2s ease",
          }}
        >
          <div className="col-11 m-auto">
            <div className="col-12">
              <div
                className="col-12 px-4 mb-4 mt-3"
                style={{
                  filter: loading ? "blur(4px)" : "none",
                  pointerEvents: loading ? "none" : "auto",
                  transition: "0.2s ease",
                }}
              >
                {/* ================= ROW 1 : Heading + Download ================= */}
                <div className="d-flex justify-content-between align-items-center mb-2 flex-wrap">
                  <h5 className="fw-bold d-flex align-items-center m-0">
                    <img
                      src="/GR-Approval64.png"
                      alt="Technical Approval"
                      style={{
                        width: "24px",
                        height: "24px",
                        marginRight: "6px",
                      }}
                    />
                    {[24, 25, 29, 40, 41].includes(RoleID)
                      ? t("Work Order Status")
                      : t("Work Order Outwards")}
                  </h5>
                  <div className="d-flex gap-2">
                    <button
                      className="btn btn-success"
                      onClick={() =>
                        exportTableByClassToExcel(
                          filteredBills,
                          "Work_Details_Outward.xlsx",
                        )
                      }
                    >
                      {t("Download Excel")}
                    </button>
                    <button
                      className="btn btn-danger"
                      onClick={() =>
                        downloadTableOnlyAsPDF(
                          "WorkOrderOutward",
                          "WorkOrderOutward.pdf",
                          "WorkOrder Outward Report",
                        )
                      }
                    >
                      {t("Download PDF")}
                    </button>
                  </div>
                </div>

                {/* ================= ROW 2 : Filters + Search ================= */}
                <CommonFilters
                  UserRole={UserRole}

                  /* Data Type */
                  showDataType={
                    UserRole === "State" && RoleID == 29
                  }
                  typeofData={typeofData}
                  settypeofData={settypeofData}

                  /* Department */
                  showDepartment={showDepartmentFilter}
                  selectedDepartment={selectedDepartment}
                  setSelectedDepartment={setSelectedDepartment}

                  /* Status */
                  showStatus={true}
                  statusofData={statusofData}
                  setstatusofData={setstatusofData}

                  /* Work Order Type */
                  showWorkOrderType={true}
                  selectedWorkType={selectedWorkType}
                  setSelectedWorkType={setSelectedWorkType}

                  /* Head Code */
                  showHeadCode={
                    ![40, 41, 29, 80, 81].includes(RoleID)
                  }
                  selectedHeadCode={selectedHeadCode}
                  setSelectedHeadCode={setSelectedHeadCode}
                  headCodeOptions={headCodeOptions}

                  /* District */
                  showDistrict={true}
                  SelectedDistrict={SelectedDistrict}
                  setSelectedDistrict={setSelectedDistrict}
                  AllDistrict={AllDistrict}
                  openDistrict={openDistrict}
                  setOpenDistrict={setOpenDistrict}
                  isAllSelected={isAllSelected}
                  toggleAllDistricts={toggleAllDistricts}
                  handleDistrictToggle={handleDistrictToggle}

                  /* Taluka */
                  showTaluka={true}
                  SelectedTaluka={SelectedTaluka}
                  setSelectedTaluka={setSelectedTaluka}
                  TalukasofDistrict={talukaOptions}

                  /* Search */
                  showSearch={true}
                  searchTerm={searchTerm}
                  setSearchTerm={setSearchTerm}
                />
              </div>

              <div className="col-12 pb-5">
                <div
                  className="m-auto mb-3"
                  style={{
                    backgroundColor: "white",
                    padding: "40px 40px",
                    boxShadow: "0px 0px 5px 1px #E4E8EC",
                    borderRadius: "20px",
                    width: "100%",
                    maxWidth: "100%",
                    overflowX: "hidden",
                  }}
                >
                  <div
                    className="col-12 tableDesign"
                    style={{
                      background: "#2C78DB",
                      overflowX: "auto",
                      overflowY: "auto",
                      maxHeight: "600px", // change height as needed
                      position: "relative",
                    }}
                  >
                    <table
                      className="m-0 p-0 WorkOrderOutward"
                      style={{
                        width: "100%",
                        borderCollapse: "collapse",
                        fontSize: "18px",
                      }}
                    >
                      <thead
                        style={{
                          position: "sticky",
                          background: "#2C78DB",
                          top: 0,
                          zIndex: 10,
                        }}
                      >
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                            fontSize: "18px",
                          }}
                        >
                          <th
                            style={{ padding: "7px 10px", minWidth: "60px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Sr.No.")}
                          </th>
                          {UserRole === "State" && RoleID != 29 ? (
                            ""
                          ) : (
                            <th
                              style={{ padding: "7px 10px", minWidth: "250px" }}
                              rowSpan={2}
                              colSpan={1}
                            >
                              {t("Head Code")}
                            </th>
                          )}
                          <th
                            style={{ padding: "7px 10px", minWidth: "120px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Administrative Year")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "120px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Taluka")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "120px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Order UID")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "150px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Order Number")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "230px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Name")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "230px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Order Type")}
                          </th>
                          <th
                            style={{ padding: "5px 8px", minWidth: "200px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Job ID")}
                          </th>
                          <th
                            style={{
                              padding: "7px 10px",
                              border: "1px solid white",
                            }}
                            rowSpan={2}
                          >
                            {t("Contractor Name")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "150px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("MHUID Number")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "100px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("District")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "100px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Cost")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "130px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Approved Work Amount")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "130px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Remaining Amount")}
                          </th>
                          {/* <th
                            style={{ padding: "7px 10px", minWidth: "130px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Paid Amount")}
                          </th> */}
                          <th
                            style={{ padding: "7px 10px", minWidth: "150px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Order Date")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "150px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Order End Date")}
                          </th>
                          <th
                            style={{ minWidth: "150px", padding: "8px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Approved GR Date")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "250px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Work Order Copy")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "150px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Creation Date")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "180px" }}
                            rowSpan={2}
                            colSpan={1}
                          >
                            {t("Extension Order (ZP Approval)")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "160px" }}
                            rowSpan={2}
                          >
                            {t("Rejected?")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "160px" }}
                            rowSpan={2}
                          >
                            {t("Remark")}
                          </th>
                          <th
                            style={{ padding: "7px 10px", minWidth: "160px" }}
                            colSpan={2}
                          >
                            {t("Approved by")}
                          </th>{" "}
                          {/* changed from 9 to 7 */}
                          {/* <th style={headerStyle} colSpan={1} rowSpan={2}>Details</th> */}
                        </tr>
                        <tr
                          style={{
                            color: "white",
                            border: "none",
                            height: "3rem",
                          }}
                        >
                          {/* <th style={headerStyle}>Deputy Engineer</th> */}
                          <th style={{ minWidth: "150px", padding: "8px" }}>
                            {isChecker
                              ? t("Checker")
                              : t("Department HOD(EE)")}
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        <>
                          {displayedGRS?.length === 0 ? (
                            <tr>
                              <td
                                colSpan="30"
                                style={{
                                  textAlign: "center",
                                  padding: "20px",
                                  backgroundColor: "#f9f9f9",
                                }}
                              >
                                {t("No data available")}
                              </td>
                            </tr>
                          ) : (
                            displayedGRS?.map((proposal, index) => {
                              const bgColor =
                                index % 2 === 0 ? "#E5F4FB" : "#CFE4F1";
                              return (
                                <tr
                                  style={{
                                    backgroundColor: bgColor,
                                    fontSize: "18px",
                                  }}
                                  key={index}
                                >
                                  <td style={{ padding: "8px 8px" }}>
                                    {indexOfFirstBill + index + 1}
                                  </td>
                                  {UserRole === "State" && RoleID != 29 ? (
                                    ""
                                  ) : (
                                    <td style={{ padding: "8px 8px" }}>
                                      {proposal.HeadCode}
                                    </td>
                                  )}
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.ProposalYear}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.ulb}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.WorkOrderID}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.WorkOrderNo}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.WorkName}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.WorkOrderType || "-"}
                                  </td>
                                  <td style={{ padding: "4px 4px" }}>
                                    {proposal.JOB_ID ?? "-"}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.ContractorName}
                                  </td>
                                  {/* <td style={{ padding: "8px" }}>
                                    {proposal.TechnicalUID}
                                  </td> */}
                             
                                  <td className="py-2">
                                    {/* {!proposal.TechnicalUID ||
                                      proposal.TechnicalUID.toUpperCase() === "NULL"
                                      ? "--"
                                      : proposal.TechnicalUID} */}
                                       {!proposal.TechnicalUID ||
                                     String(proposal.TechnicalUID).trim().toUpperCase() === "NULL" ||
                                     String(proposal.TechnicalUID).trim().toLowerCase() === "undefined" ||
                                     String(proposal.TechnicalUID).trim() === ""
                                       ? "-"
                                       : proposal.TechnicalUID}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.talulka}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {/* {proposal.ProjectCost} */}
                                    {Number(proposal.ProjectCost || 0).toLocaleString("en-IN")}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {/* {proposal.ApprovedWorkAmount} */}
                                    {Number(proposal.ApprovedWorkAmount || 0).toLocaleString("en-IN")}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {/* {proposal.BillRemainingAmount} */}
                                    {Number(proposal.BillRemainingAmount || 0).toLocaleString("en-IN")}
                                  </td>
                                  {/* <td style={{ padding: "8px 8px" }}>
                                    {proposal.PaidAmount}
                                  </td> */}
                                  <td style={{ padding: "8px 8px" }}>
                                    {formatDate(proposal.WorkOrderDate)}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {formatDate(proposal.WorkEndDate)}
                                  </td>
                                  <td>
                                    {proposal.GRApproveDate ||
                                      proposal.workApprovedGRDate || proposal.GRDate
                                      ? formatDate(
                                        proposal.GRApproveDate ||
                                        proposal.workApprovedGRDate || proposal.GRDate,
                                      )
                                      : "-"}
                                  </td>
                                  {/* <td style={{ padding: "8px 8px" }}>
  {proposal.AdminApprovedGRDate
    ? formatDate(proposal.AdminApprovedGRDate)
    : "-"}
</td> */}
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.CopyofWorkOrder ? (
                                      <a
                                        href={`${apiurl}/WorkOrderDocsImages/${proposal.CopyofWorkOrder}`}
                                        target="_blank"
                                      >
                                        {formatFileName(
                                          proposal.CopyofWorkOrder,
                                        )}
                                      </a>
                                    ) : (
                                      <p className="fw-bold text-danger my-auto">
                                        {" "}
                                        {t("No File")}
                                      </p>
                                    )}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {formatDateTime(proposal.Date)}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {isWorkOrderExpired(proposal) ? (
                                      proposal.ExtensionOrder ? (
                                        <div>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              backgroundColor: "#16C60C",
                                              color: "white",
                                              fontSize: "11px",
                                              fontWeight: "600",
                                              padding: "3px 8px",
                                              borderRadius: "10px",
                                              marginBottom: "4px",
                                            }}
                                          >
                                            ✓ {t("Approved by ZP")}
                                          </span>

                                          <br />

                                          <a
                                            href={`${apiurl}/ExtensionOrder/${proposal.ExtensionOrder}`}
                                            target="_blank"
                                            rel="noreferrer"
                                            style={{ fontSize: "11px" }}
                                          >
                                            {t("View Copy")}
                                          </a>
                                        </div>
                                      ) : (
                                        <div>
                                          <span
                                            style={{
                                              display: "inline-block",
                                              backgroundColor: "#dc2626",
                                              color: "white",
                                              fontSize: "11px",
                                              fontWeight: "600",
                                              padding: "3px 8px",
                                              borderRadius: "10px",
                                              marginBottom: "6px",
                                            }}
                                          >
                                            ⚠️ {t("Expired")}
                                          </span>

                                          <br />

                                          <button
                                            onClick={() => {
                                              setExtensionTargetWO(proposal);
                                              setExtensionFile(null);
                                              setShowExtensionModal(true);
                                            }}
                                            style={{
                                              cursor: "pointer",
                                              background:
                                                "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                              color: "white",
                                              border: "none",
                                              padding: "5px 10px",
                                              borderRadius: "6px",
                                              fontSize: "11px",
                                              display: "inline-flex",
                                              alignItems: "center",
                                              gap: "4px",
                                            }}
                                          >
                                            <img
                                              src="/Added-Work-Names64.png"
                                              alt="upload"
                                              style={{
                                                width: "12px",
                                                height: "12px",
                                              }}
                                            />
                                            {t("Upload Extension Order")}
                                          </button>
                                        </div>
                                      )
                                    ) : (
                                      "-"
                                    )}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.Status === "Pending"
                                      ? "No"
                                      : "Yes"}
                                  </td>
                                  <td style={{ padding: "8px 8px" }}>
                                    {proposal.Remark || "--"}
                                  </td>

                                  {/* <td style={{ padding: '8px', textAlign: 'center' }}>
                                                                {proposal.Approvance2 === 'true' ? (<div className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#16C60C',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✓
                                                                </div>) : proposal.Approvance2 === 'false' ? (<div
                                                                    className='m-auto'
                                                                    style={{
                                                                        width: '20px',
                                                                        height: '20px',
                                                                        borderRadius: '6px',
                                                                        backgroundColor: '#dc2626',
                                                                        border: 'none',
                                                                        display: 'flex',
                                                                        justifyContent: 'center',
                                                                        alignItems: 'center',
                                                                        fontSize: '13px',
                                                                        color: 'white',
                                                                        boxShadow: '0 2px 4px rgba(0,0,0,0.1)'
                                                                    }}
                                                                >
                                                                    ✕
                                                                </div>) : '-'}
                                                            </td> */}
                                  <td
                                    style={{
                                      padding: "8px",
                                      textAlign: "center",
                                    }}
                                  >
                                    {proposal.Approvance3 === "true" ? (
                                      <div
                                        className="m-auto"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "6px",
                                          backgroundColor: "#16C60C",
                                          border: "none",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          fontSize: "18px",
                                          color: "white",
                                          boxShadow:
                                            "0 2px 4px rgba(0,0,0,0.1)",
                                        }}
                                      >
                                        ✓
                                      </div>
                                    ) : proposal.Approvance3 === "false" ? (
                                      <div
                                        className="m-auto"
                                        style={{
                                          width: "20px",
                                          height: "20px",
                                          borderRadius: "6px",
                                          backgroundColor: "#dc2626",
                                          border: "none",
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          fontSize: "18px",
                                          color: "white",
                                          boxShadow:
                                            "0 2px 4px rgba(0,0,0,0.1)",
                                        }}
                                      >
                                        ✕
                                      </div>
                                    ) : (
                                      "-"
                                    )}
                                  </td>

                                  {/* <td style={{ padding: '8px' }}>{proposal.Proposal_copy}</td> */}
                                  {/* <td>
                                                                <button
                                                                    className='m-auto'
                                                                    onClick={() => selectedBillDetails(proposal.WorkOrderID)}
                                                                    style={{
                                                                        cursor: 'pointer',
                                                                        background: "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                                                                        color: 'white',
                                                                        border: 'none',
                                                                        padding: '8px 20px',
                                                                        borderRadius: '4px',
                                                                        fontSize: "12px",
                                                                        display: "flex",
                                                                        justifyContent: "center",
                                                                        alignItems: 'center',


                                                                    }}
                                                                >
                                                                    <img src="/view32.png" alt="view" className='me-1' style={{ width: "12px", height: "12px" }} />
                                                                    View
                                                                </button>
                                                            </td> */}
                                </tr>
                              );
                            })
                          )}
                          <tr
                            style={{
                              fontWeight: "600",
                              backgroundColor: "#f0f0f0",
                              fontSize: "18px",
                            }}
                          >
                            <td
                              colSpan={
                                UserRole === "State" && RoleID != 29 ? 11 : 12
                              }
                              style={{ textAlign: "right", padding: "8px" }}
                            >
                              {t("Page Total")}
                            </td>

                            <td style={{ padding: "8px" }}>
                              ₹ {pagetotalworkcostamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {pagetotalapprovedamt.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {pagetotalremaingamt.toLocaleString("en-IN")}
                            </td>

                            {/* remaining columns */}
                            <td colSpan={UserRole === "State" ? 19 : 20}></td>
                          </tr>
                          <tr
                            style={{
                              fontWeight: "600",
                              backgroundColor: "#f0f0f0",
                              fontSize: "18px",
                            }}
                          >
                            <td
                              colSpan={
                                UserRole === "State" && RoleID != 29 ? 11 : 12
                              }
                              style={{ textAlign: "right", padding: "8px" }}
                            >
                              {t("Gross Total")}
                            </td>

                            <td style={{ padding: "8px" }}>
                              ₹ {totalworkordercost.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {totalApproveamt1.toLocaleString("en-IN")}
                            </td>
                            <td style={{ padding: "8px" }}>
                              ₹ {totalremaningamt.toLocaleString("en-IN")}
                            </td>

                            {/* remaining columns */}
                            <td colSpan={UserRole === "State" ? 19 : 20}></td>
                          </tr>
                        </>
                      </tbody>
                    </table>
                  </div>

                  <div className="col-12 mt-4 mb-2">
                    <div className="row">
                      <div className="col-6">
                        <p
                          className="text-gray-600"
                          style={{ fontSize: "18px" }}
                        >
                          {" "}
                          {t("Showing")} {indexOfFirstBill + 1} {t("to")}{" "}
                          {Math.min(indexOfLastBill, filteredBills.length)}{" "}
                          {t("of")} {totalEntryCount} {t("entries")}
                        </p>
                      </div>
                      <div
                        className="col-6"
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "end",
                        }}
                      >
                        <GooglePagination
                          currentPage={currentPage}
                          totalPages={totalPages}
                          onPageChange={setCurrentPage}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {selectedProposal && (
            <div
              onClick={() => setSelectedProposal(null)}
              style={{
                position: "fixed",
                top: 0,
                left: 0,
                width: "100vw",
                height: "100vh",
                backgroundColor: "rgba(0, 0, 0, 0.84)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                zIndex: 9999,
              }}
            >
              <div
                onClick={(e) => e.stopPropagation()}
                style={{
                  backgroundColor: "white",
                  padding: "40px 40px",
                  borderRadius: "20px",
                  width: "50%",
                  maxHeight: "90vh",
                  overflow: "hidden",
                  boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
                  position: "relative",
                }}
              >
                <div className="col-12">
                  <div className="col-12  mb-3">
                    <div className="row">
                      <div className="col-6">
                        <h5 c>{t("Technical Sanction Details")}</h5>
                      </div>

                      <div
                        className="col-6"
                        style={{ display: "flex", justifyContent: "flex-end" }}
                      >
                        <button
                          onClick={() => setSelectedProposal(null)}
                          style={{
                            width: "32px",
                            height: "32px",
                            borderRadius: "50%",
                            backgroundColor: "red",
                            border: "none",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            cursor: "pointer",
                            fontSize: "24px",
                            fontWeight: "bold",
                            color: "white",
                            lineHeight: 1,
                          }}
                        >
                          ×
                        </button>
                      </div>
                    </div>
                  </div>

                  <div
                    className="col-12"
                    style={{
                      height: "59vh",
                      overflowX: "hidden",
                      overflowY: "scroll",
                      scrollBehavior: "smooth",
                    }}
                  >
                    <table
                      style={{
                        width: "100%",
                        height: "100%",
                        borderCollapse: "collapse",
                      }}
                    >
                      <tbody>
                        {Object.entries(selectedProposal).map(
                          ([key, value], index) => (
                            <>
                              <tr
                                key={key}
                                style={{
                                  backgroundColor:
                                    index % 2 === 0 ? "#2B75D5" : "#cce0f9",
                                  border: "1px solid #cce0f9",
                                }}
                              >
                                <td
                                  style={{
                                    fontWeight: "bold",
                                    padding: "8px",
                                    width: "40%",
                                    backgroundColor: "#2B75D5",
                                    color: "white",
                                    border: "1px solid #cce0f9",
                                  }}
                                >
                                  {key}
                                </td>
                                <td
                                  style={{
                                    padding: "8px",
                                    color: "black",
                                    backgroundColor:
                                      index % 2 === 0 ? "#E3EBF5" : "#D0DEF1",
                                  }}
                                >
                                  {/* Handle Upload Bill Copy link */}
                                  {key === "Work Order Copy" && value ? (
                                    <a
                                      href={`${apiurl}/WorkOrderDocsImages/${value}`}
                                      target="_blank"
                                      rel="noreferrer"
                                    >
                                      {value}
                                    </a>
                                  ) : value == null || value == "" ? (
                                    "-"
                                  ) : (
                                    value.toString()
                                  )}
                                </td>
                              </tr>
                            </>
                          ),
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>

        {loading && (
          <div
            style={{
              position: "fixed",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              background: "rgba(255,255,255,0.4)",
              backdropFilter: "blur(2px)",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              zIndex: 9999,
            }}
          >
            <div className="Adminloader"></div>
          </div>
        )}
      </div>

      {showExtensionModal && (
        <div
          onClick={() => !uploadingExtension && setShowExtensionModal(false)}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100vw",
            height: "100vh",
            backgroundColor: "rgba(0,0,0,0.6)",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 10000,
          }}
        >
          <div
            onClick={(e) => e.stopPropagation()}
            style={{
              backgroundColor: "white",
              padding: "30px",
              borderRadius: "16px",
              width: "420px",
              maxWidth: "90%",
              boxShadow: "0 2px 10px rgba(0,0,0,0.3)",
            }}
          >
            <h5 className="fw-bold mb-2">{t("Upload Extension Order")}</h5>

            <div
              className="p-2 mb-3"
              style={{
                backgroundColor: "#FBE7E7",
                border: "1px solid #dc3545",
                borderRadius: "6px",
              }}
            >
              <p className="mb-0" style={{ fontSize: "12px", color: "#333" }}>
                {t(
                  "The deadline for bill submission under this Work Order's Administrative Approved Year has expired. Please upload the State-approved Extension Order (obtained through the offline approval process) to proceed with bill generation.",
                )}
              </p>
            </div>

            <p style={{ fontSize: "13px" }}>
              <b>{t("Work Name")}:</b> {extensionTargetWO?.WorkName}
            </p>
            <p style={{ fontSize: "13px" }}>
              <b>{t("Work Order Number")}:</b> {extensionTargetWO?.WorkOrderNo}
            </p>

            <div className="my-3">
              <label className="fw-bold" style={{ fontSize: "13px" }}>
                {t("Extension Order Copy")}{" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <input
                type="file"
                className="form-control py-2 mt-1"
                accept=".pdf,.jpg,.jpeg,.png"
                onChange={(e) => setExtensionFile(e.target.files[0] || null)}
              />
            </div>

            <div className="d-flex justify-content-end gap-2 mt-4">
              <button
                disabled={uploadingExtension}
                onClick={() => setShowExtensionModal(false)}
                style={{
                  cursor: "pointer",
                  backgroundColor: "#dc3545",
                  color: "white",
                  border: "none",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  fontSize: "13px",
                }}
              >
                {t("Cancel")}
              </button>
              <button
                disabled={uploadingExtension || !extensionFile}
                onClick={handleUploadExtensionOrder}
                style={{
                  cursor: uploadingExtension ? "not-allowed" : "pointer",
                  background:
                    "linear-gradient(to right, #3b409e, #0067ab, #0f79ba, #0098d5)",
                  color: "white",
                  border: "none",
                  padding: "6px 14px",
                  borderRadius: "20px",
                  fontSize: "13px",
                  opacity: uploadingExtension ? 0.7 : 1,
                }}
              >
                {uploadingExtension ? t("Uploading...") : t("Submit")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default WorkOrderOutwards;
